<template>
  <BaseTag v-bind="$attrs" :options="options">
    <template v-for="item in Object.keys($slots)" #[item]="data">
      <slot :name="item" v-bind="data || {}"></slot>
    </template>
  </BaseTag>
</template>

<script setup lang="ts">
  import { ref } from 'vue';
  import { type DictOption, getDictOptions } from '@mts/render/api';
  import BaseTag from './BaseTag.vue';

  defineOptions({
    name: 'DictTag',
  });

  const props = defineProps<{ code: string }>();

  const options = ref<DictOption[]>([]);
  getDictOptions({ dataTypeCode: props.code }).then((res) => {
    options.value = res as DictOption[];
  });
</script>
